import React, { useMemo } from 'react';
import classNames from 'classnames';
import { DateUtils } from '@vectord/utils';
import { pickBy } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import {
  appliedFiltersSelector,
  removeFilter,
  SBAT_GROUP_FILTERS,
  SBAT_GROUP_FILTER_LABELS,
  isValidSbatGroupFilter,
} from 'features/classCreation';
import styles from './SbatGroupFilterChips.module.scss';
import ToggleChip from 'components/ToggleChip';

function SbatGroupFilterChips() {
  const dispatch = useDispatch();
  const appliedFilters = useSelector(appliedFiltersSelector);

  const filters = useMemo(() => {
    return pickBy(appliedFilters, isValidSbatGroupFilter);
  }, [appliedFilters]);

  const handleRemoveFilter = (filterKey) => {
    dispatch(removeFilter(filterKey));
  };

  return Object.keys(filters).map((filterKey) => {
    let label = `${SBAT_GROUP_FILTER_LABELS[filterKey]}: `;

    if (
      filterKey === SBAT_GROUP_FILTERS.fromDate ||
      filterKey === SBAT_GROUP_FILTERS.toDate
    ) {
      label = label + DateUtils.toDDMMMYYYY(filters[filterKey]);
    } else {
      const filterList = filters[filterKey].reduce(
        (result, filter) => result + `${filter.label}, `,
        ''
      );
      label = label + filterList.slice(0, -2);
    }

    return (
      <ToggleChip
        key={filterKey}
        isAdded
        label={label}
        className={classNames(styles.root, 'h5 m-r-xxs')}
        onRemove={() => handleRemoveFilter(filterKey)}
      />
    );
  });
}

export default SbatGroupFilterChips;
